import {
  READY_CHANGE_REPORT,
  CLEAR_REPORT
} from '../actions/reportActions'

const initialState = {
  title: '',
  id: '',
  type: null
}

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case READY_CHANGE_REPORT: {
      const { title, id, type } = action.payload

      return Object.assign(
        {},
        state,
        {
          title: title,
          id: id,
          type: type
        }
      )
    }
    case CLEAR_REPORT:
      return Object.assign(
        {},
        state,
        initialState
      )
    default:
      return state
  }
}

export default reportReducer
